"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialFocus = void 0;
var react_1 = require("react");
var useInitialFocus = function (ref, focus) {
    (0, react_1.useEffect)(function () {
        var _a;
        if (focus)
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [ref, focus]);
};
exports.useInitialFocus = useInitialFocus;
